









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Well extends Vue {}
